import { Form, Button, Container, Alert } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser, logout} from './authSlice';
import { useNavigate, Link } from 'react-router-dom';

// import api from '../../api/api';
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap CSS is imported
import '../custom_styles.css';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const dispatch = useDispatch();
  const { status, loading, error } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  // const [resetEmail, setResetEmail] = useState('');
  // const [resetStatus, setResetStatus] = useState(null);
  // const [resetError, setResetError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(loginUser(form));
    if (loginUser.fulfilled.match(result)) {
        console.log("Login successful:", result.payload);
        if (result.payload.user.must_change_password) {
            navigate('/change-password');
            return;
        }
        if (!result.payload.user.email_verified) {
            navigate('/verify-email', { state: { email: form.email } });
            return;
        }
        navigate('/dashboard');
    }
  };
  // useEffect(() => {
  //       dispatch(logout());
  // }, []);

  return (
    <Container className="mt-5" style={{ maxWidth: '400px' }}>
        <h3>Sign In</h3>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
                type="email"
                value={form.email}
                onChange={(e) => setForm({...form, email: e.target.value})}
                required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
                type="password"
                onChange={(e) => setForm({...form, password: e.target.value})}
                required
            />
          </Form.Group>
          <Button className="ms-2 btn-primary fw-bold" type="submit" disabled={loading || (status === 'loading')}>
                {status === 'loading' ? 'Signing in...' : 'Sign In'}
          </Button>
        </Form>
        <div className="d-flex gap-1 mt-5 justify-content-end">
          <Button as={Link} to="/signup" className="btn-missed-path-2 mr-4">
            Not yet Registered?<br />Sign Up
          </Button>
          <Button as={Link} to="/forgotPassword" className="btn-alternate-path">
            Forgot Password?<br />Reset
          </Button>       
        </div> 
        {error && <p className="text-danger mt-2">{error}</p>}
    </Container>
  );
}
